import classNames from 'classnames';
import React from 'react';
import EfLink from '../ef-link';
import './index.scss';

interface EfButtonProps {
    /**
     * 按钮链接
     */
    href?: string;
    /**
     * 主题色
     */
    theme?: 'default' | 'white' | 'black';
    /**
     * 按钮 type
     */
    type?: 'link_more' | 'buy_now';
    /**
     * 是否置灰
     */
    disabled?: boolean;
    /**
     * 点击回调
     */
    onClick?: any;
    /**
     * children
     */
    children?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
    /**
     * 埋点
     */
    dataLayer?: any;
}

/**
 * 维护:谢保林
 *
 * 通用按钮
 */
const EfButton: React.FC<EfButtonProps> = ({ href, theme = 'default', type, disabled, onClick, children, className, ...reset }) => {
    const prefixCls = `ef-button`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
        [`${prefixCls}-${type}`]: type,
        [`${prefixCls}-disabled`]: disabled,
    });

    return (
        <EfLink href={href} onClick={onClick} className={classes} {...reset}>
            {children}
        </EfLink>
    );
};

export default EfButton;
